import React, { useState, useEffect } from 'react';
import '../css/Admin/AccountDetail.css';
import ResponseMsg2 from '../general/ResponseMsg2';
import HeadingArea from '../general/HeadingArea';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';

const AccountDetail = ({setLoading}) => {
  const [bank, setBank] = useState([]);
  const [formData, setFormData] = useState({
    bank_name: '',
    ifsc_code: '',
    acc_holder: '',
    account_no: '',
    acc_type: '',
    branch: '',
    upi: '',
    upi_img: null,
    status: 'Active',
  });
  const [editFormData, setEditFormData] = useState(null);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [selectedBank, setSelectedBank] = useState('');
const [showDelete, setShowDelete] = useState(false);
const [showEdit, setShowEdit] = useState(false);


  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'file') {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else if (type === 'checkbox') {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 'Active' : 'Inactive',
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const fetchBank = async (e) => {
                setLoading(true);
                try {
                    const response = await fetch('https://api.kcian.in/get-bank');
    
                    if (response.ok) {
                        const data = await response.json();
                        setBank(data);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        console.error('Failed to fetch coupon');
                    }
                } catch (error) {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                }
            };


                    useEffect(() => {
                      fetchBank();
                    }, [])


  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        payload.append(key, formData[key]);
      }
    }

    try {
      const response = await fetch('https://api.kcian.in/add-bank', {
        method: 'POST',
        body: payload,
      });
      const result = await response.json();

fetchBank();
      setFormData({
            bank_name: '',
    ifsc_code: '',
    acc_holder: '',
    account_no: '',
    acc_type: '',
    branch: '',
    upi: '',
    upi_img: null,
    status: 'Active',
      })
setResponse2({ message: 'Bank Account Added Successfully!', status: 'success' });
setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    } catch (error) {
      setResponse2({ message: 'Something Went Wrong.', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };


  const handleShowDelete = (myBank) => {
    setSelectedBank(myBank);
    setShowDelete(true);
  }

    const handleShowEdit = (myBank) => {
    setSelectedBank(myBank);
    setEditFormData(myBank);
    setShowEdit(true);
  }


    const handleEditChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'file') {
      setEditFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else if (type === 'checkbox') {
      setEditFormData((prev) => ({
        ...prev,
        [name]: checked ? 'Active' : 'Inactive',
      }));
    } else {
      setEditFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Submit edited data
  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    for (const key in editFormData) {
      if (editFormData[key] !== null && editFormData[key] !== undefined) {
        payload.append(key, editFormData[key]);
      }
    }

    try {
      const response = await fetch(`https://api.kcian.in/edit-bank/${selectedBank.id}`, {
        method: 'PUT',
        body: payload,
      });

      if (response.ok) {
        const updatedBank = await response.json();
        fetchBank();
        setShowEdit(false);
        setResponse2({ message: 'Bank Details updated successfully!', status: 'success' });
      } else {
        setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (error) {
      setResponse2({ message: 'Error updating bank.', status: 'error' });
    }
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  };


            const handleDelete = async (bankId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-bank/${bankId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setBank((prevData) => prevData.filter((product) => product.id !== bankId));
        setShowDelete(false);
        setResponse2({ message: 'Bank Deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting bank:', error);
    }
  };



  return (
    <>    <section className='py-4'>
      <div className='px-4'>

<HeadingArea message1='General Settings' message2='Account for Fees' />

        <div className='row'>
          <div className='col-lg-4 col-12 my-2'>
            <div className='profile-card'>
              <p className='fw-bold fm-mont fs-5 text-center mb-4'>Add New Bank</p>

              <form onSubmit={handleSubmit} encType='multipart/form-data'>
                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Bank Name*</label>
                  <input
                    type='text'
                    name='bank_name'
                    className='profile-input'
                    value={formData.bank_name}
                    onChange={handleChange}
                    required
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>IFSC Code*</label>
                  <input
                    type='text'
                    name='ifsc_code'
                    className='profile-input'
                    value={formData.ifsc_code}
                    onChange={handleChange}
                    required
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Account Holder*</label>
                  <input
                    type='text'
                    name='acc_holder'
                    className='profile-input'
                    value={formData.acc_holder}
                    onChange={handleChange}
                    required
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Account Number*</label>
                  <input
                    type='text'
                    name='account_no'
                    className='profile-input'
                    value={formData.account_no}
                    onChange={handleChange}
                    required
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Account Type</label>
                  <input
                    type='text'
                    name='acc_type'
                    className='profile-input'
                    value={formData.acc_type}
                    onChange={handleChange}
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Branch</label>
                  <input
                    type='text'
                    name='branch'
                    className='profile-input'
                    value={formData.branch}
                    onChange={handleChange}
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>UPI ID</label>
                  <input
                    type='text'
                    name='upi'
                    className='profile-input'
                    value={formData.upi}
                    onChange={handleChange}
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Upload UPI QR Image</label>
                  <input
                    type='file'
                    name='upi_img'
                    className='profile-input'
                    onChange={handleChange}
                    accept='image/*'
                  />
</div>                </div>

                <div className='mb-4 form-check'>
                  <input
                    type='checkbox'
                    name='status'
                    className='form-check-input'
                    checked={formData.status === 'Active'}
                    onChange={handleChange}
                    id='statusCheck'
                  />
                  <label className='form-check-label' htmlFor='statusCheck'>
                    Active
                  </label>
</div>               

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


<div className='text-center'>
                <button type='submit' className='profile-btn'>
                  Add Bank
                </button></div>

              </form>
            </div>
          </div>
{/* left ends */}


<div className='col-lg-8 col-12 my-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
    <div className='profile-card'>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>S No</th>
    <th>Bank Name</th>
    <th>Account No</th>
    <th>Status</th>
    <th className='rounded-end-4'>Actions</th>
</thead>

{bank.map((myBank, index) => (
  <tr className='account-tr'>
    <td>{index+1}</td>
    <td>{myBank.bank_name}</td>
    <td>{myBank.account_no}</td>
    <td>{myBank.status}</td>
    <td><MdOutlineEdit onClick={() => handleShowEdit(myBank)} className='account-icon1' /> &nbsp;&nbsp;<RiDeleteBin6Line onClick={() => handleShowDelete(myBank)} className='account-icon2' /></td>
  </tr>
))}


</table>
</div>

    </div>
</div>


        </div>
        {/* row ends */}
      </div>
    </section>

{showEdit && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading mb-4'>Edit Bank Account!</p>
<form onSubmit={handleEditSubmit} className='row g-3' encType='multipart/form-data'>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Bank Name*</label>
            <input
              type='text'
              name='bank_name'
              className='profile-input'
              value={editFormData.bank_name}
              onChange={handleEditChange}
              required
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>IFSC Code*</label>
            <input
              type='text'
              name='ifsc_code'
              className='profile-input'
              value={editFormData.ifsc_code}
              onChange={handleEditChange}
              required
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Account Holder*</label>
            <input
              type='text'
              name='acc_holder'
              className='profile-input'
              value={editFormData.acc_holder}
              onChange={handleEditChange}
              required
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Account Number*</label>
            <input
              type='text'
              name='account_no'
              className='profile-input'
              value={editFormData.account_no}
              onChange={handleEditChange}
              required
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Account Type</label>
            <input
              type='text'
              name='acc_type'
              className='profile-input'
              value={editFormData.acc_type}
              onChange={handleEditChange}
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Branch</label>
            <input
              type='text'
              name='branch'
              className='profile-input'
              value={editFormData.branch}
              onChange={handleEditChange}
            />
          </div>
        </div>

        <div className='mb-2 col-md-6'>
          <div className='profile-input-area'>
            <label className='profile-badge'>UPI ID</label>
            <input
              type='text'
              name='upi'
              className='profile-input'
              value={editFormData.upi}
              onChange={handleEditChange}
            />
          </div>
        </div>

  <div className='mb-2 col-md-6'>
            <div className='profile-input-area'>
              <label className='profile-badge'>Upload New UPI QR</label>
            
              <input
                type='file'
                name='upi_img'
                className='profile-input'
                onChange={handleEditChange}
                accept='image/*'
              />
            </div>
              {/* Show old QR image if exists */}
{editFormData.upi_img && typeof editFormData.upi_img === 'string' && editFormData.upi_img.trim() !== '' && (
  <div className='mb-2'>
    <img
      src={`https://api.kcian.in/inUploads/${editFormData.upi_img}`}
      alt='Current UPI QR'
      style={{ maxWidth: '150px', display: 'block', marginBottom: '8px', borderRadius: '6px' }}
    />
  </div>
)}

          </div>


        <div className='mb-2 form-check'>
          <input
            type='checkbox'
            name='status'
            className='form-check-input'
            checked={editFormData.status === 'Active'}
            onChange={handleEditChange}
            id='editStatusCheck'
          />
          <label className='form-check-label' htmlFor='editStatusCheck'>
            Active
          </label>
        </div>

        <div>
          <button type='submit' className='profile-btn me-2'>
            Update Bank
          </button>
          <button type='button' className='profile-btn2' onClick={() => setShowEdit(false)}>
            Cancel
          </button>
        </div>
      </form>
</div>
</section>
</>
            )}


{showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove Bank Account!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Bank Name</th>
    <th>IFSC Code</th>
    <th>Account Holder</th>
    <th>Account No</th>
    <th>Account Type</th>
    <th>Branch</th>
    <th>UPI Id</th>
    <th>UPI Code</th>
    <th className='rounded-end-4'>Status</th>
</thead>

<tr className='account-tr'>
<td>{selectedBank.bank_name}</td>
<td>{selectedBank.ifsc_code}</td>
<td>{selectedBank.acc_holder}</td>
<td>{selectedBank.account_no}</td>
<td>{selectedBank.acc_type}</td>
<td>{selectedBank.branch}</td>
<td>{selectedBank.upi || 'NA'}</td>
<td>
  {selectedBank.upi_img && selectedBank.upi_img.trim() !== '' ? (
    <img src={`https://api.kcian.in/inUploads/${selectedBank.upi_img}`} style={{ height: '5em' }} alt="UPI QR" />
  ) : (
    'NA'
  )}
</td>
<td>{selectedBank.status}</td>
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the bank account will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedBank.id)}>Remove Account</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

</>
  );
};

export default AccountDetail;
